import { type PropsWithChildren } from 'react';
import Footer from 'shared/studio/Footer/Footer';
import { type FooterData } from 'types/studio/footer';

type DynamicLanderLayoutProps = PropsWithChildren<{
  footerData: FooterData | undefined;
}>;

export const DynamicLanderLayout = ({ children, footerData }: DynamicLanderLayoutProps) => (
  <>
    {children}
    {footerData && <Footer data={footerData} />}
  </>
);
